import React, { useCallback, useMemo } from "react";
import { TouchableOpacity } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { CheckoutFeedbackQuestionType } from "../../../../../../../projection/checkoutFeedback/checkoutFeedback.constants";
import { DOMAIN } from "../../../../../i18n/i18n";
import { useCheckoutQuestionFeedbackForId } from "../../behaviors/useCheckoutQuestionFeedback";
import { CheckoutQuestionItem } from "../CheckoutQuestionItem";
import { style as buttonCheckoutQuestionItemStyle } from "./ButtonCheckoutQuestionItem.style";

const ACTIVE_OPACITY = 0.6;

const ButtonCheckoutQuestionItem: CheckoutQuestionItem<CheckoutFeedbackQuestionType.BUTTON> = ({
  checkoutQuestion,
  checkoutQuestionParentId,
  testID,
}) => {
  const { feedback, onChange } = useCheckoutQuestionFeedbackForId({ id: checkoutQuestionParentId });

  const optionText = useI18nMessage({ domain: DOMAIN, id: checkoutQuestion.translationKey });
  const handleOnPress = useCallback(
    () => onChange({ checkoutQuestionId: checkoutQuestionParentId, checkoutQuestionFeedback: checkoutQuestion.id }),
    [onChange, checkoutQuestion.id, checkoutQuestionParentId],
  );

  const style = useMemo(() => buttonCheckoutQuestionItemStyle(), []);

  const checked = feedback === checkoutQuestion.id;

  return (
    <TouchableOpacity
      accessibilityLabel={testID}
      activeOpacity={ACTIVE_OPACITY}
      style={[style.button, checked && style.buttonActive]}
      testID={testID}
      onPress={handleOnPress}
    >
      <Text level={3} style={[style.text, checked && style.textActive]} variant="action">
        {optionText}
      </Text>
    </TouchableOpacity>
  );
};

export { ButtonCheckoutQuestionItem };
